module.exports = __webpack_public_path__ + "img/fair.80bcc208.svg";